import { Alert, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'
import InputBase from 'design-system/input/base'
import NavLinkBack from 'components/NavLinkBack'
import ButtonBase from 'design-system/button'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Login } from '@mui/icons-material'
import ContentModal from 'components/ContentModal'
import { sendEmailPasswordReset } from 'services/auth'
import { LOGIN } from 'navigation/CONSTANTS'

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('')
  const [state, setState] = useState<IStateStdTypes>('idle')
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [formError, setFormError] = useState('')
  const navigate = useNavigate()

  const validateEmail = (value: string) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return re.test(String(value).toLowerCase())
  }

  const handleResetPassword = async () => {
    if (!validateEmail(email)) {
      setFormError('E-mail inválido')
      return
    }
    try {
      await sendEmailPasswordReset({ email: email })
      setIsDialogOpen(true)
    } catch (e) {
      console.error('Erro ao enviar e-mail de redefinição:', e)
    }
  }

  const handleConfirm = async () => {
    setIsDialogOpen(false)
    navigate(LOGIN)
  }

  return (
    <Grid
      container
      spacing={2}
      p={2}
      width='100%'
      maxWidth={1200}
      margin='0 auto'
    >
      <NavLinkBack to={LOGIN} />
      <Grid size={12}>
        <Typography variant='h5'>Esqueceu sua senha?</Typography>
      </Grid>
      <Grid size={12}>
        <Alert variant='outlined' color='info' severity='info'>
          Insira seu e-mail para redefinir a senha
        </Alert>
      </Grid>
      <Grid container size={12} spacing={3} maxWidth={1200}>
        <Grid size={6}></Grid>
        <InputBase
          placeholder='E-mail'
          onChange={e => setEmail(e.target.value.trim())}
          disabled={state === 'loading'}
        />
        <ContentModal
          open={isDialogOpen}
          title='E-mail enviado!'
          description='Se este endereo está cadastrado conosco, você receberá um e-mail para redefinir sua senha. Caso não o encontre em sua caixa de entrada, verifique no seu spam ou lixo eletrônico.'
          onConfirm={handleConfirm}
        />
        <Grid size={12} justifyContent={'center'} container>
          <ButtonBase
            loading={state == 'loading'}
            onClick={() => {
              handleResetPassword()
            }}
          >
            Redefinir senha
          </ButtonBase>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ForgotPasswordPage
